var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./AutoshipAddGoodsPage.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-6ddd083e!../../node_modules/vue-loader/lib/selector?type=template&index=0!./AutoshipAddGoodsPage.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/AutoshipAddGoodsPage.vue
// module id = 268
// module chunks = 1